import script from "./userCountForm.vue?vue&type=script&setup=true&lang=js"
export * from "./userCountForm.vue?vue&type=script&setup=true&lang=js"

import "./userCountForm.vue?vue&type=style&index=0&id=35a70bac&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35a70bac"]])

export default __exports__